const pricing = {
  kyiv: {
    insurance: 20,
    junior: {
      premises_type: {
        room1: {
          basic: 200,
          maintain: 150,
        },
        room2: {
          basic: 300,
          maintain: 200,
        },
        room3: {
          basic: 400,
          maintain: 275,
        },
        room4: {
          basic: 500,
          maintain: 350,
        },
        home: {
          basic: 0,
          maintain: 0,
        },
        office: {
          basic: 0,
          maintain: 0,
        },
        per_hour: {
          basic: 0,
          maintain: 0,
        },
        windows: {
          basic: 0,
          maintain: 0,
        },
      },
      additional_services: {
        clean_refrigerator: 30,
        clean_refrigerator_full: 60,
        clean_oven: 45,
        range_hood: 30,
        clean_microwave: 30,
        clean_cabinet: 45,
        clean_wardrobe: 30,
        clean_balcony: 30,
        clean_balcony_inner: 60,
        clean_window: 30,
        clean_window_full: 40,
        clean_window_side: 15,
        ironing: 45,
        washing_dishes: 45,
        per_hour: 75,
        toilet: 30,
        additional_toilet: 60,
        keys_delivery: 50,
      },
    },
    middle: {

      premises_type: {
        room1: {
          basic: 250,
          maintain: 175,
        },
        room2: {
          basic: 350,
          maintain: 250,
        },
        room3: {
          basic: 450,
          maintain: 325,
        },
        room4: {
          basic: 550,
          maintain: 400,
        },
        home: {
          basic: 0,
          maintain: 0,
        },
        office: {
          basic: 0,
          maintain: 0,
        },
        per_hour: {
          basic: 0,
          maintain: 0,
        },
        windows: {
          basic: 0,
          maintain: 0,
        },
      },
      additional_services: {
        clean_refrigerator: 35,
        clean_refrigerator_full: 70,
        clean_oven: 55,
        range_hood: 35,
        clean_microwave: 35,
        clean_cabinet: 55,
        clean_wardrobe: 35,
        clean_balcony: 35,
        clean_balcony_inner: 70,
        clean_window: 35,
        clean_window_full: 45,
        clean_window_side: 17.5,
        ironing: 55,
        washing_dishes: 55,
        per_hour: 85,
        toilet: 35,
        additional_toilet: 70,
        keys_delivery: 50,
      },
    },
    senior: {
      premises_type: {
        room1: {
          basic: 300,
          maintain: 200,
        },
        room2: {
          basic: 400,
          maintain: 275,
        },
        room3: {
          basic: 500,
          maintain: 350,
        },
        room4: {
          basic: 600,
          maintain: 425,
        },
        home: {
          basic: 0,
          maintain: 0,
        },
        office: {
          basic: 0,
          maintain: 0,
        },
        per_hour: {
          basic: 0,
          maintain: 0,
        },
        windows: {
          basic: 0,
          maintain: 0,
        },
      },
      additional_services: {
        clean_refrigerator: 40,
        clean_refrigerator_full: 80,
        clean_oven: 60,
        range_hood: 40,
        clean_microwave: 40,
        clean_cabinet: 60,
        clean_wardrobe: 40,
        clean_balcony: 40,
        clean_balcony_inner: 80,
        clean_window: 40,
        clean_window_full: 50,
        clean_window_side: 20,
        ironing: 60,
        washing_dishes: 60,
        per_hour: 100,
        toilet: 40,
        additional_toilet: 80,
        keys_delivery: 50,
      },
    },
  },
  dnepr: {
    insurance: 20,
    junior: {
      premises_type: {
        room1: {
          basic: 140,
          maintain: 110,
        },
        room2: {
          basic: 210,
          maintain: 140,
        },
        room3: {
          basic: 300,
          maintain: 210,
        },
        room4: {
          basic: 350,
          maintain: 230,
        },
        home: {
          basic: 0,
          maintain: 0,
        },
        office: {
          basic: 0,
          maintain: 0,
        },
        per_hour: {
          basic: 0,
          maintain: 0,
        },
        windows: {
          basic: 0,
          maintain: 0,
        },
      },
      additional_services: {
        clean_refrigerator: 20,
        clean_refrigerator_full: 40,
        clean_oven: 30,
        range_hood: 20,
        clean_microwave: 20,
        clean_cabinet: 30,
        clean_wardrobe: 20,
        clean_balcony: 20,
        clean_balcony_inner: 40,
        clean_window: 20,
        clean_window_full: 30,
        clean_window_side: 10,
        ironing: 30,
        washing_dishes: 30,
        per_hour: 50,
        toilet: 20,
        additional_toilet: 40,
        keys_delivery: 25,
      },
    },
    middle: {

      premises_type: {
        room1: {
          basic: 165,
          maintain: 115,
        },
        room2: {
          basic: 250,
          maintain: 165,
        },
        room3: {
          basic: 320,
          maintain: 235,
        },
        room4: {
          basic: 400,
          maintain: 285,
        },
        home: {
          basic: 0,
          maintain: 0,
        },
        office: {
          basic: 0,
          maintain: 0,
        },
        per_hour: {
          basic: 0,
          maintain: 0,
        },
        windows: {
          basic: 0,
          maintain: 0,
        },
      },
      additional_services: {
        clean_refrigerator: 25,
        clean_refrigerator_full: 50,
        clean_oven: 35,
        range_hood: 25,
        clean_microwave: 25,
        clean_cabinet: 35,
        clean_wardrobe: 25,
        clean_balcony: 25,
        clean_balcony_inner: 50,
        clean_window: 25,
        clean_window_full: 35,
        clean_window_side: 12,
        ironing: 35,
        washing_dishes: 35,
        per_hour: 50,
        toilet: 25,
        additional_toilet: 50,
        keys_delivery: 27,
      },
    },
    senior: {

      premises_type: {
        room1: {
          basic: 215,
          maintain: 140,
        },
        room2: {
          basic: 285,
          maintain: 190,
        },
        room3: {
          basic: 380,
          maintain: 260,
        },
        room4: {
          basic: 450,
          maintain: 305,
        },
        home: {
          basic: 0,
          maintain: 0,
        },
        office: {
          basic: 0,
          maintain: 0,
        },
        per_hour: {
          basic: 0,
          maintain: 0,
        },
        windows: {
          basic: 0,
          maintain: 0,
        },
      },
      additional_services: {
        clean_refrigerator: 28,
        clean_refrigerator_full: 55,
        clean_oven: 40,
        range_hood: 28,
        clean_microwave: 28,
        clean_cabinet: 40,
        clean_wardrobe: 28,
        clean_balcony: 28,
        clean_balcony_inner: 55,
        clean_window: 28,
        clean_window_full: 35,
        clean_window_side: 14,
        ironing: 40,
        washing_dishes: 40,
        per_hour: 70,
        toilet: 28,
        additional_toilet: 55,
        keys_delivery: 35,
      },
    },
  },
  kharkov: {
    insurance: 20,
    junior: {
      premises_type: {
        room1: {
          basic: 200,
          maintain: 150,
        },
        room2: {
          basic: 300,
          maintain: 200,
        },
        room3: {
          basic: 400,
          maintain: 275,
        },
        room4: {
          basic: 500,
          maintain: 350,
        },
        home: {
          basic: 0,
          maintain: 0,
        },
        office: {
          basic: 0,
          maintain: 0,
        },
        per_hour: {
          basic: 0,
          maintain: 0,
        },
        windows: {
          basic: 0,
          maintain: 0,
        },
      },
      additional_services: {
        clean_refrigerator: 30,
        clean_refrigerator_full: 60,
        clean_oven: 45,
        range_hood: 30,
        clean_microwave: 30,
        clean_cabinet: 45,
        clean_wardrobe: 30,
        clean_balcony: 30,
        clean_balcony_inner: 60,
        clean_window: 30,
        clean_window_full: 40,
        clean_window_side: 15,
        ironing: 45,
        washing_dishes: 45,
        per_hour: 75,
        toilet: 30,
        additional_toilet: 60,
        keys_delivery: 50,
      },
    },
    middle: {

      premises_type: {
        room1: {
          basic: 250,
          maintain: 175,
        },
        room2: {
          basic: 350,
          maintain: 250,
        },
        room3: {
          basic: 450,
          maintain: 325,
        },
        room4: {
          basic: 550,
          maintain: 400,
        },
        home: {
          basic: 0,
          maintain: 0,
        },
        office: {
          basic: 0,
          maintain: 0,
        },
        per_hour: {
          basic: 0,
          maintain: 0,
        },
        windows: {
          basic: 0,
          maintain: 0,
        },
      },
      additional_services: {
        clean_refrigerator: 35,
        clean_refrigerator_full: 70,
        clean_oven: 55,
        range_hood: 35,
        clean_microwave: 35,
        clean_cabinet: 55,
        clean_wardrobe: 35,
        clean_balcony: 35,
        clean_balcony_inner: 70,
        clean_window: 35,
        clean_window_full: 45,
        clean_window_side: 17.5,
        ironing: 55,
        washing_dishes: 55,
        per_hour: 85,
        toilet: 35,
        additional_toilet: 70,
        keys_delivery: 50,
      },
    },
    senior: {
      premises_type: {
        room1: {
          basic: 300,
          maintain: 200,
        },
        room2: {
          basic: 400,
          maintain: 275,
        },
        room3: {
          basic: 500,
          maintain: 350,
        },
        room4: {
          basic: 600,
          maintain: 425,
        },
        home: {
          basic: 0,
          maintain: 0,
        },
        office: {
          basic: 0,
          maintain: 0,
        },
        per_hour: {
          basic: 0,
          maintain: 0,
        },
        windows: {
          basic: 0,
          maintain: 0,
        },
      },
      additional_services: {
        clean_refrigerator: 40,
        clean_refrigerator_full: 80,
        clean_oven: 60,
        range_hood: 40,
        clean_microwave: 40,
        clean_cabinet: 60,
        clean_wardrobe: 40,
        clean_balcony: 40,
        clean_balcony_inner: 80,
        clean_window: 40,
        clean_window_full: 50,
        clean_window_side: 20,
        ironing: 60,
        washing_dishes: 60,
        per_hour: 100,
        toilet: 40,
        additional_toilet: 80,
        keys_delivery: 50,
      },
    },
  },
};

export default pricing;
